import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';

import { Picture, Details } from './components';

const useStyles = makeStyles((theme) => ({
	root: {},
	deliverables: {
		marginTop: theme.spacing(3),
	},
	members: {
		marginTop: theme.spacing(3),
	},
}));

const Overview = (props) => {
	const { operator, className, ...rest } = props;

	const classes = useStyles();

	return (
		<Grid2
			{...rest}
			className={clsx(classes.root, className)}
			container
			spacing={3}
		>
			<Grid2 item size={6}>
				<Picture operator={operator} />
			</Grid2>
			<Grid2 item size={6}>
				<Details operator={operator} />
			</Grid2>
		</Grid2>
	);
};

Overview.propTypes = {
	className: PropTypes.string,
	operator: PropTypes.object.isRequired,
};

export default Overview;
